(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["article-share"] && !Shopify.designMode) return;
  try {
    document.querySelectorAll('.article-share__copy').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var url = this.getAttribute('data-url');
        if (navigator.clipboard) {
          navigator.clipboard.writeText(url).then(function() {
            btn.style.opacity = '1';
            setTimeout(function() { btn.style.opacity = ''; }, 1500);
          });
        }
      });
    });
  } catch(e) { console.error(e); }
})();

})();
